require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/fn/is-iterable.js
// module id = ../../../node_modules/core-js/library/fn/is-iterable.js
// module chunks = 0